import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import { connect } from 'react-redux';

import React, { PureComponent } from 'react';
import { Module } from '@cuemath/comps';

import { getAll as getChapterContents } from 'actions/chapter-contents';
import ChapterContent from './view';

class ChapterContentContainer extends PureComponent {
  static propTypes = {
    chapterVersionId: PropTypes.string.isRequired,
    match: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types,
    chapterContent: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    actions: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.refreshData();
  }

  refreshData() {
    const { actions, chapterVersionId } = this.props;
    actions.getChapterContents({ chapter_version_id: chapterVersionId });
  }

  render() {
    const { chapterContent, match } = this.props;

    return (
      <Module
        module={ChapterContent}
        resource={chapterContent || {}}
        chapterContent={chapterContent ? chapterContent.data : {}}
        match={match}
      />
    );
  }
}

export default connect(
  ({ chapterContent }, { chapterVersionId }) => ({
    chapterContent: store.getAll(chapterContent, {
      chapter_version_id: chapterVersionId,
    }),
  }),
  dispatch => ({
    actions: bindActionCreators({ getChapterContents }, dispatch),
  }),
)(ChapterContentContainer);
